import React, { useState } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Button,
  Box,
  Collapse,
  Toolbar,
  Typography,
  Menu,
  Container,
  MenuItem,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Divider,
  Drawer,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../../assets/logo-main.png';
import { logos } from '../../utils/logos';
import { logoutUser } from '../../../redux/user';

const membershipMenu = [
  { label: 'Manage Users', value: 'manageuser' },
  { label: 'Registration', value: 'register' },
  { label: 'Approve Pending Members', value: 'memberapprove' },
];

const adminMenu = [{ label: 'Setting', value: 'setting' }];
const settings = ['Profile', 'Logout', 'Change PW'];

const CustomMenu = styled(Menu)({
  '& .MuiPaper-root': {
    backgroundColor: '#6573c3',
    color: 'white',
  },
});

function Header(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElMembership, setAnchorElMembership] = useState(null);
  const [anchorElAdmin, setAnchorElAdmin] = useState(null);

  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [openMembership, setOpenMembership] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(false);

  const user = useSelector((state) => state.user);
  const logoImage = logos[useSelector((state) => state.user.userData.group)];
  const matches = useMediaQuery('(max-width:768px)');

  const isAdmin = !!user?.userData?.isAdmin;
  const isSuperAdmin = user?.userData?.role === 'super admin';

  const closeAllMenus = () => {
    setAnchorElMembership(null);
    setAnchorElAdmin(null);
    setMobileDrawerOpen(false);
    setOpenMembership(false);
    setOpenAdmin(false);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenMembershipMenu = (event) => {
    setAnchorElMembership(event.currentTarget);
  };

  const handleOpenAdminMenu = (event) => {
    setAnchorElAdmin(event.currentTarget);
  };

  const handleCloseMembershipMenu = () => {
    setAnchorElMembership(null);
  };

  const handleCloseAdminMenu = () => {
    setAnchorElAdmin(null);
  };

  const handleMenuButton = (name) => {
    const lowerName = name.toLowerCase();
    navigate('/' + lowerName);
    closeAllMenus();
  };

  const handleSettingButton = (name) => {
    const lowerName = name.toLowerCase().split(' ').join('');

    if (lowerName === 'logout') {
      dispatch(logoutUser(user)).then((res) => {
        if (res.payload.logoutSuccess) {
          navigate('/login');
        } else {
          alert('Log Out Failed');
        }
      });
    } else if (lowerName === 'profile') {
      navigate('/profile');
    } else if (lowerName === 'changepw') {
      navigate('/changepw');
    }

    setAnchorElUser(null);
    closeAllMenus();
  };

  const handleClickMembership = () => {
    setOpenMembership((prev) => !prev);
  };

  const handleClickAdmin = () => {
    setOpenAdmin((prev) => !prev);
  };

  const mobileDrawer = (
    <Box sx={{ width: 300, height: '100%', backgroundColor: '#f8fafc' }} role="presentation">
      <Box
        sx={{
          px: 2.5,
          py: 2,
          background: 'linear-gradient(135deg, #5c6bc0 0%, #7986cb 100%)',
          color: 'white',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Menu
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          {user?.userData?.name}
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.8 }}>
          {user?.userData?.email}
        </Typography>
      </Box>

      <List
        subheader={
          <ListSubheader
            sx={{
              backgroundColor: '#f8fafc',
              color: '#6b7280',
              fontWeight: 700,
              fontSize: '12px',
              lineHeight: '32px',
            }}
          >
            메뉴
          </ListSubheader>
        }
      >
        <ListItemButton
          onClick={() => {
            handleMenuButton('Organization');
          }}
        >
          <ListItemText primary="Organization" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
        </ListItemButton>

        {isAdmin && (
          <ListItemButton
            onClick={() => {
              handleMenuButton('Dashboard');
            }}
          >
            <ListItemText primary="Dashboard" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
          </ListItemButton>
        )}

        <ListItemButton
          onClick={() => {
            handleMenuButton('Guideline');
          }}
        >
          <ListItemText primary="Guideline / Manual" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
        </ListItemButton>
      </List>

      {isAdmin && (
        <>
          <Divider />
          <List
            subheader={
              <ListSubheader
                sx={{
                  backgroundColor: '#f8fafc',
                  color: '#6b7280',
                  fontWeight: 700,
                  fontSize: '12px',
                  lineHeight: '32px',
                }}
              >
                관리자 메뉴
              </ListSubheader>
            }
          >
            <ListItemButton onClick={handleClickMembership}>
              <ListItemText primary="Membership" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
              {openMembership ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openMembership} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ backgroundColor: '#eef2ff' }}>
                {membershipMenu.map((item) => (
                  <ListItemButton
                    key={item.value}
                    sx={{ pl: 4 }}
                    onClick={() => {
                      handleMenuButton(item.value);
                    }}
                  >
                    <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 13 }} />
                  </ListItemButton>
                ))}
              </List>
            </Collapse>

            {isSuperAdmin && (
              <>
                <ListItemButton onClick={handleClickAdmin}>
                  <ListItemText primary="Admin" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
                  {openAdmin ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={openAdmin} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={{ backgroundColor: '#eef2ff' }}>
                    {adminMenu.map((item) => (
                      <ListItemButton
                        key={item.value}
                        sx={{ pl: 4 }}
                        onClick={() => {
                          handleMenuButton(item.value);
                        }}
                      >
                        <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 13 }} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </>
            )}
          </List>
        </>
      )}

      <Divider />

      <List
        subheader={
          <ListSubheader
            sx={{
              backgroundColor: '#f8fafc',
              color: '#6b7280',
              fontWeight: 700,
              fontSize: '12px',
              lineHeight: '32px',
            }}
          >
            계정
          </ListSubheader>
        }
      >
        <ListItemButton
          onClick={() => {
            handleSettingButton('Profile');
          }}
        >
          <ListItemText primary="Profile" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
        </ListItemButton>

        <ListItemButton
          onClick={() => {
            handleSettingButton('Change PW');
          }}
        >
          <ListItemText primary="Change PW" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
        </ListItemButton>

        <ListItemButton
          onClick={() => {
            handleSettingButton('Logout');
          }}
        >
          <ListItemText primary="Logout" primaryTypographyProps={{ fontSize: 14, fontWeight: 700, color: '#d32f2f' }} />
        </ListItemButton>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: '#5c6bc0',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            height: '100px',
            px: 2,
          }}
        >
          <Button
            onClick={handleOpenUserMenu}
            sx={{
              flexShrink: 0,
              borderRadius: 1,
              backgroundImage: `url(${logoImage || logo})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              '&:hover': {
                bgcolor: 'white',
              },
              backgroundColor: 'white',
              width: '140px',
              height: '70px',
              padding: 0,
              mr: 2,
            }}
          />

          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mt: 1,
                lineHeight: 1.2,
              }}
            >
              {props.user.userData.name}
            </Typography>
            <Typography variant="subtitle2" sx={{ opacity: 0.95 }}>
              {props.user.userData.email}
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          {matches ? (
            <IconButton
              color="inherit"
              onClick={() => setMobileDrawerOpen(true)}
              sx={{
                border: '1px solid rgba(255,255,255,0.2)',
                backgroundColor: 'rgba(255,255,255,0.08)',
                borderRadius: 2,
              }}
            >
              <MenuIcon />
            </IconButton>
          ) : null}
        </Toolbar>

        <Container
          maxWidth={false}
          sx={{
            height: '48px',
            backgroundColor: '#7986cb',
            display: matches ? 'none' : 'flex',
          }}
        >
          <Button
            onClick={() => {
              handleMenuButton('Organization');
            }}
            sx={{
              width: '160px',
              height: '100%',
              color: 'white',
              textTransform: 'none',
            }}
          >
            Organization
          </Button>

          {isAdmin && (
            <Button
              onClick={() => {
                handleMenuButton('Dashboard');
              }}
              sx={{
                width: '160px',
                height: '100%',
                color: 'white',
                textTransform: 'none',
              }}
            >
              Dashboard
            </Button>
          )}

          {isAdmin && (
            <Button
              onClick={handleOpenMembershipMenu}
              endIcon={<ArrowDropDownIcon />}
              sx={{
                width: '160px',
                height: '100%',
                color: 'white',
                textTransform: 'none',
              }}
            >
              Membership
            </Button>
          )}

          {isSuperAdmin && (
            <Button
              onClick={handleOpenAdminMenu}
              endIcon={<ArrowDropDownIcon />}
              sx={{
                width: '160px',
                height: '100%',
                color: 'white',
                textTransform: 'none',
              }}
            >
              Admin
            </Button>
          )}

          <CustomMenu
            id="menu-membership"
            anchorEl={anchorElMembership}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={Boolean(anchorElMembership)}
            onClose={handleCloseMembershipMenu}
          >
            {membershipMenu.map((page) => (
              <MenuItem
                key={page.value}
                onClick={() => {
                  handleMenuButton(page.value);
                  handleCloseMembershipMenu();
                }}
              >
                <Typography sx={{ textAlign: 'center' }}>{page.label}</Typography>
              </MenuItem>
            ))}
          </CustomMenu>

          <CustomMenu
            id="menu-admin"
            anchorEl={anchorElAdmin}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={Boolean(anchorElAdmin)}
            onClose={handleCloseAdminMenu}
          >
            {adminMenu.map((page) => (
              <MenuItem
                key={page.value}
                onClick={() => {
                  handleMenuButton(page.value);
                  handleCloseAdminMenu();
                }}
              >
                <Typography sx={{ textAlign: 'center' }}>{page.label}</Typography>
              </MenuItem>
            ))}
          </CustomMenu>

          <Button
            onClick={() => {
              handleMenuButton('Guideline');
            }}
            sx={{
              width: '160px',
              height: '100%',
              color: 'white',
              textTransform: 'none',
            }}
          >
            Guideline / Manual
          </Button>

          <Button
            onClick={() => {
              handleSettingButton('logout');
            }}
            sx={{
              height: '100%',
              color: 'white',
              textTransform: 'none',
              px: 3,
            }}
          >
            Logout
          </Button>
        </Container>
      </AppBar>

      <Menu
        id="menu-appbar-user"
        anchorEl={anchorElUser}
        keepMounted
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {settings.map((setting) => (
          <MenuItem
            key={setting}
            onClick={() => {
              handleSettingButton(setting);
            }}
          >
            <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
          </MenuItem>
        ))}
      </Menu>

      <Drawer
        anchor="right"
        open={mobileDrawerOpen}
        onClose={() => setMobileDrawerOpen(false)}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: matches ? 'block' : 'none',
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 300,
          },
        }}
      >
        {mobileDrawer}
      </Drawer>

      <Outlet />
    </>
  );
}

export default Header;
